import { MainView } from "@tlc/ls2pac/app/views/MainView";
import * as React from "react";
import { SearchBar } from "../SearchBar";
import { useLocationConfiguration } from "../LocationConfiguration";
import { LS2PacSearchDatabaseManager } from "@tlc/ls2pac/app/managers/SearchDatabaseManager";
import { LS2PAC_CONSTANTS } from "../../../main/constants";
import { TLCEventManager } from "../../events/EventManager";
import { LS2PAC_Utils } from "@tlc/ls2pac/app/utils/Utils";
import { useSyndeticsConfig } from "../SyndeticsConfig";
import { Ls2pacResultsView } from "@tlc/ls2pac/app/views/results/Ls2pacResultsView";
import SearchBarContainer from "../SearchBarContainer";
import { useLanguage } from "../Language";
import useBackToLink from "./resource/useBackToLink";
import { useLocation } from "react-router-dom";

export const LegacyApp: React.FC = () => {
  const { locationConfiguration } = useLocationConfiguration();
  const { syndeticsConfig } = useSyndeticsConfig();
  const { translate } = useLanguage();
  const location = useLocation();
  useBackToLink(translate("results"), location);

  React.useEffect(() => {
    // load MainApp here

    console.log("Render Legacy App");

    const mainView = new MainView();

    const ls2pacDBConfig = LS2PacSearchDatabaseManager.getDatabaseConfig(
      LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
    );
    const ls2pacSearchResultsView = new Ls2pacResultsView({
      databaseConfig: ls2pacDBConfig,
      tmpl: "tmpl/results/ls2pacListView.html",
      errorTmpl: "tmpl/results/spellingSuggestions.html",
    });

    return () => {
      sessionStorage.removeItem("backToLink");
      sessionStorage.removeItem("backToLinkText");
      console.log("Unmount Legacy App");
      ls2pacSearchResultsView?.cleanup();
      // reset search db to ls2pac when leaving results
      LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
        LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
      );
      mainView?.cleanup();
      // TODO need to remove any listeners
    };
  }, []);

  return (
    <>
      <SearchBarContainer>
        <SearchBar
          autoFocus={true}
          sx={{ m: "0 auto" }}
          limitToKids={false}
          voiceSearchEnabled={
            locationConfiguration?.pacSettings?.displaySettings?.voiceInterface
          }
          onClickSearch={(searchEvent) => {
            const currentDatabaseConfig =
              LS2PacSearchDatabaseManager.getCurrentDatabaseConfig();
            if (!currentDatabaseConfig.requiresSearchTerm) {
              LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
                LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
              );
            }
            const event = {
              searchString: searchEvent.searchTerm,
              searchType: "",
            };
            if (searchEvent.searchType === "author") {
              event.searchType = "author";
            }
            TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onSearch, event);
          }}
          onClickTitle={(resource) => {
            var data = LS2PAC_Utils.getFakePagingDataToSendToFullDetails([
              resource,
            ]);
            window.location.href = `#section=resource&resourceid=${resource.id}&currentIndex=0&view=fullDetailsDetailsTab`;
          }}
          syndeticsClientCode={syndeticsConfig?.clientCode}
          branchFilters={locationConfiguration?.filterBranches}
        ></SearchBar>
      </SearchBarContainer>
      <div key={location.hash} id="mainPage"></div>
    </>
  );
};
